import React from 'react';
import PropTypes from 'prop-types';
import Accordion from './accordion';
import DaysLinks from './days-links';
import SelectPanel from './select-panel';
import { PRODUCT_TAG_CAR } from '../../../general/js/basket/constants';
import BackLink from './back-link';
import PopupLinkInfo from './popup-link-info';
import ButtonClear from './button-clear';
import {
    ROUTE_DAYS, ROUTE_TICKETS, SCENARIO_PARKING,
    ROUTE_EXTRAS, SCENARIO_STANDARD_WITH_EXTRAS
} from './constants';
import { hasValue } from '../../../general/js/general-helpers';

export default class SelectParkingForm extends React.Component {
    constructor(props) {
        super(props);
        this.formHeading = React.createRef();
    }

    componentDidMount() {
        this.formHeading.current.focus();
    }

    getPrevRoute() {
        let prevRoute = ROUTE_TICKETS;

        if (this.props.currentScenario === SCENARIO_PARKING) {
            prevRoute = ROUTE_DAYS;
        }

        if (this.props.currentScenario === SCENARIO_STANDARD_WITH_EXTRAS) {
            prevRoute = ROUTE_EXTRAS;
        }

        return prevRoute;
    }

    renderCarPanel() {
        const parkingList = this.props.parkingList;

        if (!parkingList || !parkingList.length) return null;

        const carParking = parkingList.filter((parkingProduct) =>
            parkingProduct.tag === PRODUCT_TAG_CAR)[0];

        if (!carParking) return null;

        return <SelectPanel
            dictionary={this.props.dictionary}
            key={carParking.id}
            product={carParking}
            productGroupsList={this.props.productGroupsList}
            onApplyProductsQuantity={this.props.onApplyProductsQuantity}
        />;
    }

    renderCarPanels(parkingList) {
        if (!Array.isArray(parkingList) || !parkingList.length) return null;

        return parkingList.map((parking) => (
            <SelectPanel
                dictionary={this.props.dictionary}
                key={parking.id}
                product={parking}
                productGroupsList={this.props.productGroupsList}
                onApplyProductsQuantity={this.props.onApplyProductsQuantity}
                rootCssClass='tb-panels-list__item'
            />
        ));
    }

    renderAccordion() {
        const parkingList = this.props.parkingList;

        const filteredParkingList = parkingList.filter((parkingProduct) =>
            parkingProduct.tag !== PRODUCT_TAG_CAR);

        if (!filteredParkingList.length) return null;

        return (
            <Accordion triggerText="See More Vehicles" triggerOpenedText="Show less vehicles">
                {this.renderCarPanels(filteredParkingList)}
            </Accordion>
        );
    }

    render() {
        return (
            <div className="tb-form">
                <h2 className="tb-form__heading headline" tabIndex="-1" ref={this.formHeading}>{this.props.dictionary.parkingStepTitle}</h2>
                <DaysLinks productGroupsList={this.props.productGroupsList} />
                <div className="tb-form__header">
                    <h3 className="title">Number of vehicles</h3>
                    {
                        hasValue(this.props.dictionary.parkingInformationLinkUrl) &&
                        hasValue(this.props.dictionary.parkingInformationLinkText) &&
                        <PopupLinkInfo
                            href={this.props.dictionary.parkingInformationLinkUrl}>{this.props.dictionary.parkingInformationLinkText}</PopupLinkInfo>
                    }
                </div>
                <div className="tb-form__list">
                    {this.renderCarPanel()}
                </div>
                <div className="tb-form__footer">
                    <ButtonClear onClick={this.props.onClearSelection}>Clear Selection</ButtonClear>
                    <div className="tb-form__footer-copy copy">
                        {this.props.dictionary.ParkingText}
                    </div>
                    {this.renderAccordion()}
                    <div className="tb-form__change-step">
                        <BackLink route={this.getPrevRoute()}>Back</BackLink>
                    </div>
                </div>
            </div>
        );
    }
}

SelectParkingForm.propTypes = {
    dictionary: PropTypes.object.isRequired,
    parkingList: PropTypes.array,
    productGroupsList: PropTypes.array,
    currentScenario: PropTypes.string.isRequired,
    onApplyProductsQuantity: PropTypes.func,
    onClearSelection: PropTypes.func
};
